const Team = () => {
    return ( 
        <div>
             <div class="home_meet_team" id="team">
               <div class="home_meet_team_container">
                  <div class="home_road_map_heading aos-init aos-animate" data-aos="fade-up" data-aos-duration="1000">
                     <h3><em>MEET </em> THE TEAM</h3>
                  </div>
                  <div class="home_meet_team_slider">
                     <div  class="slick-list">
                        <div class="home_meet_team_inner slick-slide slick-cloned slick-active" data-slick-index="-1" id="" aria-hidden="false" tabindex="-1">
                           <div class="home_meet_team_img">    
                              <img src="images/team1.png" title="" alt="" width="100%"/>
                           </div>
                           <div class="home_meet_team_text">
                              <h3>Mohamed Rafat</h3>
                              <h4> Artist, Designer and the Brains</h4>
                              <a href="https://www.instagram.com/mohamedrafat_/" target="_blank"><i class="fa fa-instagram"></i></a>
                           </div>
                        </div>
                        <div class="home_meet_team_inner slick-slide slick-current slick-active slick-center" data-slick-index="0" aria-hidden="false" tabindex="-1" role="option" aria-describedby="slick-slide10">
                           <div class="home_meet_team_img">    
                              <img src="images/team2.png" title="" alt="" width="100%"/>
                           </div>
                           <div class="home_meet_team_text">
                              <h3>Alexandra Sullivan</h3>
                              <h4>Writer, Editor</h4>
                              <a href="https://www.linkedin.com/mwlite/in/alexandra-sullivan-65a26471/" target="_blank"><i class="fa fa-linkedin"></i></a>
                           </div>
                        </div>
                        <div class="home_meet_team_inner slick-slide slick-active" data-slick-index="1" aria-hidden="false" tabindex="-1" role="option" aria-describedby="slick-slide11">
                           <div class="home_meet_team_img">    
                              <img src="images/team3.png" title="" alt="" width="100%"/>
                           </div>
                           <div class="home_meet_team_text">
                              <h3>Karan Kumar Saddi</h3>
                              <h4>Blockchain Developer</h4>
                              <a href="https://www.linkedin.com/in/karan-kumar-saddi-b0b448143/" target="_blank"><i class="fa fa-linkedin"></i></a>
                           </div>
                        </div>
                        <div class="home_meet_team_inner slick-slide slick-active" data-slick-index="2" aria-hidden="false" tabindex="-1" role="option" aria-describedby="slick-slide12">
                           <div class="home_meet_team_img">    
                              <img src="images/team4.png" title="" alt="" width="100%"/>
                           </div>
                           <div class="home_meet_team_text">
                              <h3>Aleksander Balos</h3>
                              <h4>Founder, Charity ceo, Artist, Designer</h4>
                              <a href="https://en.wikipedia.org/wiki/Aleksander_Balos" target="_blank"><i class="fa fa-wikipedia-w"></i></a>
                           </div>
                        </div>

                        <div class="home_meet_team_inner slick-slide slick-active" data-slick-index="2" aria-hidden="false" tabindex="-1" role="option" aria-describedby="slick-slide12">
                           <div class="home_meet_team_img">    
                              <img src="images/Drakezz.png" title="" alt="" width="100%"/>
                           </div>
                           <div class="home_meet_team_text">
                              <h3>Ash Evans</h3>
                              <h4>Marketing Partner</h4>
                              {/* <a href=" https://cryptonftexperts.com/" target="_blank"><i class="fa fa-wikipedia-w"></i></a> */}
                              <a href="https://www.1cfsdigital.com/1st-choice-digital-solutions-story/" target="_blank"><i class="fa fa-wikipedia-w"></i></a>
                           </div>
                        </div>
                        <div class="home_meet_team_inner slick-slide slick-active" data-slick-index="2" aria-hidden="false" tabindex="-1" role="option" aria-describedby="slick-slide12">
                           <div class="home_meet_team_img">    
                              <img src="images/31.png" title="" alt="" width="100%"/>
                           </div>
                           <div class="home_meet_team_text">
                              <h3>Mz. Nad <br/>Siddique</h3>
                              <h4>Community Management</h4>
                              {/* <a href="https://www.linkedin.com/in/a-b-siddique-807811230/" target="_blank"><i class="fa fa-linkedin"></i></a> */}
                              {/* <a href=" https://cryptonftexperts.com/" target="_blank"><i class="fa fa-wikipedia-w"></i></a> */}
                              <a href="https://www.linkedin.com/in/mz-nad-06b516209/" target="_blank"><i class="fa fa-linkedin"></i></a>
                           </div>
                        </div>
                     </div>
                  </div>
               </div>
            </div>
        </div>
        
     );
}
 
export default Team;